import { OrderBundleEdge } from '@/core/services/types/getOrderBundles/responseTypes'
import { NewOrderBundle } from '@/enums/general'
import { convertSrcSet } from '@/utils/ui'

export type ExtractOrdersReturnType = NewOrderBundle[]

export const extractOrderBundles = (edges: OrderBundleEdge[]): ExtractOrdersReturnType => {
  return edges.map((edge) => {
    const deepestOrderNode = edge.node.orders.edges.map((e) => ({
      ...e.node,
      product: {
        ...e.node.product,
        productImages: convertSrcSet({ images: e.node.product.productImages, noMobile: true })
      }
    }))

    return {
      ...edge.node,
      orders: deepestOrderNode
    }
  })
}
